module.exports = __webpack_public_path__ + "img/9788984775152.72d54f8f.jpg";